import { ClipboardCopy } from '@components/ClipboardCopy/ClipboardCopy'
import { Box, Text } from '@ui'
import { useStore } from 'store/store'
import { shortAddress } from 'ui/utils/utils'
import { useMyUserId, usePrimaryWallet } from 'use-towns-client'

import { FundSmartAccountOptions } from './FundSmartAccountOptions'
import { TipOption } from './types'

export function InsufficientTipBalance(props: {
    setTipValue: (tipValue: TipOption | undefined) => void
    onInsufficientBalance?: () => void
    enableUsdc?: boolean
}) {
    const { setTipValue, onInsufficientBalance, enableUsdc } = props
    const setFundWalletModalType = useStore((state) => state.setFundWalletModalType)

    const userId = useMyUserId()
    const { data: primaryWallet } = usePrimaryWallet({ rootWallet: userId })

    if (primaryWallet) {
        if (primaryWallet.type === 'smartAccount') {
            return (
                <>
                    <FundSmartAccountOptions
                        setTipValue={setTipValue}
                        setFundWalletModalType={setFundWalletModalType}
                        enableUsdc={enableUsdc}
                        onInsufficientBalance={onInsufficientBalance}
                    />
                </>
            )
        } else {
            return (
                <Box centerContent gap="md">
                    <Text textAlign="center" color="gray2" size="sm">
                        Your primary wallet does not have enough funds. Send funds to{' '}
                    </Text>
                    <ClipboardCopy
                        color="default"
                        clipboardContent={primaryWallet.address}
                        label={shortAddress(primaryWallet.address ?? '')}
                    />
                </Box>
            )
        }
    }

    return (
        <FundSmartAccountOptions
            setTipValue={setTipValue}
            setFundWalletModalType={setFundWalletModalType}
            enableUsdc={enableUsdc}
            onInsufficientBalance={onInsufficientBalance}
        />
    )
}
